import { gql } from "@apollo/client";


export const GET_FILTERED_ANIMALS = gql`
  query FilteredAnimals($domain: String!, $filters: [SimpleAnimalQueryFilter!]!) {
    animal {
      filtered(domain: $domain, filters: $filters) {
        animal_id
        animal_number
        feedcurve
        feedcurve_id
        fk_feedcurve_milestones: feedcurve_milestones
        milestone
        milestone_id
        group
      }
    }
  }
`

export interface FilteredAnimals {
  animal_id: number
  animal_number: number
  feedcurve?: string
  feedcurve_id?: number,
  fk_feedcurve_milestones?: number,
  milestone?: string
  milestone_id?: number
  group?: string
}

export interface FilteredAnimalsResponse {
  animal: {
    filtered: FilteredAnimals[]
  }
}
